<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Create New Session</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <div class="form-group">
    <label class="field-title" for="accountIdInput">Account ID</label>
    <input
      id="accountIdInput"
      ngbAutofocus
      class="form-control"
      name="accountIdInput"
      [formControl]="accountIds"
      (keyup.enter)="createSession(false)"
      type="number"
      min="1"
      required
    />

    <label class="field-title" for="reconDateInput">Recon Date</label>
    <nf-datepicker
      id="reconDateInput"
      name="reconDateInput"
      [formControl]="reconDate"
      [format]="dateFormat"
    >
    </nf-datepicker>

    <label class="field-title" for="periodLength">Period Length</label>
    <ng-select
      id="periodLength"
      name="periodLength"
      [items]="windowSizes"
      placeholder="Period Length"
      [formControl]="periodLength"
      [closeOnSelect]="false"
    >
      <ng-template ng-option-tmp let-item="item">
        <div [ngbTooltip]="item" container="body" class="ellipsis">
          {{ item }}
        </div>
      </ng-template>
    </ng-select>

    <ng-container *ngIf="periodLength.value === FromDate">
      <label class="field-title" for="FromDate">From Date</label>
      <nf-datepicker
        id="FromDate"
        name="FromDate"
        [formControl]="fromDate"
        [format]="dateFormat"
      >
      </nf-datepicker>
    </ng-container>
    <ng-container *ngIf="isLIBAccount && !checkingLIB">
      <label class="field-title" for="selectedBasis"
        >Load with Specific Basis (LIB)</label
      >
      <ng-select
        id="selectedBasis"
        name="selectedBasis"
        [items]="accountBasis"
        placeholder="Basis"
        [formControl]="selectedBasis"
        [closeOnSelect]="false"
      >
        <ng-template ng-option-tmp let-item="item">
          <div [ngbTooltip]="item" container="body" class="ellipsis">
            {{ item }}
          </div>
        </ng-template>
      </ng-select>
    </ng-container>
    <ng-container *ngIf="checkingLIB">
      <hs-loader
        class="{{ checkingLIB ? 'active' : '' }}"
        [loading]="checkingLIB"
        [label]="labelLIB"
        [showText]="checkingLIB"
      ></hs-loader>
    </ng-container>
  </div>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <button nf-button="cancel" (click)="activeModal.dismiss()">Cancel</button>
  <button
    nf-button="primary"
    [disabled]="submitDisabled || checkingLIB"
    (click)="createSession(false)"
    data-cy="continue-modal-button"
  >
    Create &amp; Close Prior
  </button>
  <button
    nf-button="primary"
    [disabled]="submitDisabled || checkingLIB"
    (click)="createSession(true)"
  >
    Create
  </button>
</div>
